import {
  FRIEND_REQUESTS_FETCH_SUCCESS,
  FRIEND_REQUESTS_FETCH_ERROR,
  SEND_FRIEND_REQUEST_SUCCESS,
  SEND_FRIEND_REQUEST_ERROR,
  ANSWER_FRIEND_REQUEST_SUCCESS,
  ANSWER_FRIEND_REQUEST_ERROR,
} from './types';
import { baseUrl } from '../constants/baseUrl';

import { fetchWithAccessToken } from './helperAction';

export const fetchFriendRequests = (currentUserID) => async (dispatch) => {
  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}friendship/requests/${currentUserID}`,
        method: 'GET',
      }),
    );
    const body = await response.json();
    let friendRequests = {};
    switch (response.status) {
      case 200:
      case 201:
        await dispatch({
          type: FRIEND_REQUESTS_FETCH_SUCCESS,
          payload: body,
        });
        friendRequests = body;
        break;
      default:
        await dispatch({
          type: FRIEND_REQUESTS_FETCH_ERROR,
        });
    }
    return friendRequests;
  } catch (e) {
    dispatch({
      type: FRIEND_REQUESTS_FETCH_ERROR,
    });
    return {};
  }
};

export const sendFriendRequest = (addressee, currentUserID, statusCode) => async (dispatch) => {
  const request = {
    requester: currentUserID,
    addressee,
    statusCode,
    specifier: currentUserID,
  };

  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}friendship`,
        method: 'POST',
        body: JSON.stringify(request),
      }),
    );

    switch (response.status) {
      case 201:
      case 200:
        dispatch({
          type: SEND_FRIEND_REQUEST_SUCCESS,
        });
        break;
      default:
        dispatch({
          type: SEND_FRIEND_REQUEST_ERROR,
        });
    }
  } catch (e) {
    dispatch({ type: SEND_FRIEND_REQUEST_ERROR });
  }
};

export const acceptFriendRequest = (request) => async (dispatch) => {
  const updatedAnswer = {
    id: request.id,
    requester: request.requester,
    addressee: request.addressee,
    statusCode: 2,
    specifier: request.addressee,
  };

  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}friendship/${request.id}`,
        method: 'PUT',
        body: JSON.stringify(updatedAnswer),
      }),
    );

    switch (response.status) {
      case 201:
      case 200:
        dispatch({
          type: ANSWER_FRIEND_REQUEST_SUCCESS,
        });
        break;
      default:
        dispatch({
          type: ANSWER_FRIEND_REQUEST_ERROR,
          payload: new Error(),
        });
    }
  } catch (e) {
    dispatch({ type: ANSWER_FRIEND_REQUEST_ERROR, payload: e });
  }
};
